import { FC, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { PermissionKeys } from '../../enums';
import { Forbidden } from '../../pages';
import { useHasPermission } from '../../utils';
import { ErrorFallback } from '../error-fallback/error-fallback.component';
import { Loading } from '../loading/loading.component';

interface Props {
    requiredPermission?: PermissionKeys | PermissionKeys[];
    skipOrganisationCheck?: boolean;
    children?: ReactNode;
}

export const ProtectedRoute: FC<Props> = ({ requiredPermission, children, skipOrganisationCheck }) => {
    const { hasPermission, isLoading } = useHasPermission();

    if (isLoading) return <Loading fullscreen />;

    if (requiredPermission && !hasPermission(requiredPermission, skipOrganisationCheck)) return <Forbidden />;

    return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};
